import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'profi-template-list-skeleton',
    templateUrl: './template-list-skeleton.component.html',
    styleUrls: ['./template-list-skeleton.component.scss'],
    standalone: false
})
export class TemplateListSkeletonComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
